import { render, staticRenderFns } from "./DeleteDashboardConfirm.vue?vue&type=template&id=515263ce&"
import script from "./DeleteDashboardConfirm.vue?vue&type=script&lang=js&"
export * from "./DeleteDashboardConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports